import { z } from "zod";

export const userRoleSchema = z.enum(["admin", "manager", "user"]);

export const profileSchema = z.object({
  id: z.string(),
  email: z.string().nullable(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  role: userRoleSchema.nullable(),
  team: z.string().nullable(),
  manager_id: z.string().nullable(),
  created_at: z.string(),
});

export const profilesListSchema = z.array(profileSchema);

export type UserRole = z.infer<typeof userRoleSchema>;
export type Profile = z.infer<typeof profileSchema>;

/** Minimal profile fields for team/RPC scoping (dashboard, reports). */
export type ProfileTeamScope = {
  role?: UserRole | null;
  team?: string | null;
};
